"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pascalCase = void 0;
const words_1 = require("./words");
function pascalCase(str) {
    return (0, words_1.words)(str)
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join('');
}
exports.pascalCase = pascalCase;
